import { Component, inject, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NonMembersTableComponent } from '@app/areas/non-members/components';
import { PortalTheme } from '@app/@shared/models';
import { ApplicationProfileService } from '@app/@shared/services/application-profile.service';

@UntilDestroy()
@Component({
  template: '<app-non-members-table [theme]="theme" />',
  styleUrls: ['./non-members.component.scss'],
  standalone: true,
  imports: [NonMembersTableComponent],
})
export class NonMembersComponent implements OnInit {
  protected theme!: PortalTheme;
  private readonly applicationProfileService = inject(ApplicationProfileService);

  ngOnInit(): void {
    this.applicationProfileService.applicationProfile$.subscribe((profile) => {
      this.theme = profile.PortalTheme.Theme;
    });
  }
}
